import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { authKeys } from "@/lib/query";

const authOptionsSchema = z.object({ signUp: z.boolean() });

export type AuthOptions = z.infer<typeof authOptionsSchema>;

/**
 * What the sign-in screens may offer — today, whether people can create their
 * own accounts (`ALLOW_SIGNUP`, `src/lib/signup.ts`). Fixed for the life of the
 * server process, so it is read once.
 */
export function useAuthOptions() {
  return useQuery({
    queryKey: authKeys.options,
    staleTime: Number.POSITIVE_INFINITY,
    queryFn: async (): Promise<AuthOptions> => {
      const res = await fetch("/api/auth-options");
      if (!res.ok) throw new Error(`Couldn't load sign-in options (${res.status})`);
      return authOptionsSchema.parse(await res.json());
    },
  });
}
